import { render, staticRenderFns } from "./chartNum.vue?vue&type=template&id=2a0e0c62&scoped=true"
import script from "./chartNum.vue?vue&type=script&lang=js"
export * from "./chartNum.vue?vue&type=script&lang=js"
import style0 from "./chartNum.vue?vue&type=style&index=0&id=2a0e0c62&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0e0c62",
  null
  
)

export default component.exports